import React, { ReactNode } from "react";
import { TriangleAlert } from "lucide-react";
import i18n from "@/i18n";

interface ErrorBoundaryProps {
  renderNull?: boolean;
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: unknown) {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _errorInfo: React.ErrorInfo) {
    // TODO log to sentry
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
          <div className="max-w-md space-y-6">
            <div className="space-y-2">
              <h1 className="text-4xl font-bold tracking-tight">
                {i18n.t("errorBoundary.title")}
              </h1>
              <p className="text-muted-foreground">
                {i18n.t("errorBoundary.description")}
              </p>
            </div>

            <TriangleAlert className="mx-auto size-32" />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
